import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {EmployeeNameWithAvatar} from 'shared/components';
import {InteractiveTable} from 'main/components';
import {endpoints, types} from 'main/tools';
import {Line} from 'rc-progress';
import _ from 'lodash';
import PerformanceSubnav from 'main/containers/performance/components/PerformanceSubnav';
import RevieweeListEmptyState from './RevieweesListEmptyState';
import AwaitingTag from '../../AwaitingTag';
import CheckinRelation from 'main/stores/performance/CheckinRelation';

const COLOURS_BY_PERCENTAGE = [
  {
    minPercent: 0,
    colour: '#00B7B3',
  },
  {
    minPercent: 70,
    colour: '#FABA4F',
  }
];

const DaysSinceLastCheckIn = ({model}) => {
  const {daysSinceLastCheckin, totalDays} = model;

  if (daysSinceLastCheckin == null) return <FormattedMessage id='performance.NO_CHECK_INS'/>;

  const percentage = _.min([daysSinceLastCheckin * 100 / totalDays, 100]);
  const colour = _.findLast(COLOURS_BY_PERCENTAGE, c => percentage >= c.minPercent).colour;
  return (
    <div>
      <div className='table-cell align-middle'>
        <FormattedMessage id='DAYS_COUNT' values={{count: daysSinceLastCheckin}} />
      </div>
      <div style={{width: '100px'}} className='table-cell align-middle relative pl1'>
        <Line className='absolute' percent={percentage} strokeColor={colour} strokeWidth={3} trailWidth={3}/>
      </div>
    </div>
  );
};

const Reviewee = ({model}) => (
  <div className='flex align-items-middle'>
    <EmployeeNameWithAvatar employee={model.reviewee} size='sm'/>
    <div className='pl1'>
      <AwaitingTag status={model.status}/>
    </div>
  </div>
);

const COLUMNS = [
  {
    header: 'performance.Employee',
    width: 4,
    component: Reviewee
  },
  {
    header: 'performance.Suggested Frequency',
    width: 4,
    render: ({frequency}) => <FormattedMessage id={frequency}/>
  },
  {
    header: 'performance.DAYS_SINCE_LAST_CHECK_IN',
    width: 4,
    component: DaysSinceLastCheckIn
  }
];

const RevieweesContainer = observer(({scope}) => (
  <div>
    <PerformanceSubnav scope={scope}/>
    <div className='Container'>
      <InteractiveTable
        columns={COLUMNS}
        showLinks={false}
        showAddButton={false}
        empty={RevieweeListEmptyState}
        showRoute={({reviewee}) => `/reviewees/${reviewee.id}`}
        proxy={{
          type: 'async',
          endpoint: endpoints.PERFORMANCE.REVIEWEES,
          modelType: types.PERFORMANCE.CHECKIN_RELATIONS,
          model: CheckinRelation
        }}
      />
    </div>
  </div>
));

export default RevieweesContainer;
